import { DocumentScanner } from "@mui/icons-material";
import { Button, Chip, Stack } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";

import { useExtractDocumentMutation } from "AdvisoryManagement/Api/Mutations/useExtractDocumentMutation";
import { AddContract } from "AdvisoryManagement/Components/Client/Contracts/AddContract";
import { ContractsTable } from "AdvisoryManagement/Components/Client/Contracts/ContractsTable";
import { ActiveUploadsBadge } from "AdvisoryManagement/Shared/DocumentExtract/DocumentExtractModal";
import FileButton from "Shared/Buttons/FileButton";
import { SectionCard } from "Shared/Cards/SectionCard";

type FilterType = "all" | "pending" | "approved" | "rejected";

export const ContractsInProgress = () => {
	const { advisoryCaseId } = useParams<{ advisoryCaseId: string }>();
	const { mutate: uploadDocument } = useExtractDocumentMutation(advisoryCaseId);
	const [activeFilter, setActiveFilter] = useState<FilterType>("all");
	// const [showIncomplete, setShowIncomplete] = useState(false);

	const onAddContractFromDocument = (
		documentType: string,
		file: File,
		fileName: string,
	) => {
		uploadDocument({ documentType, file, fileName });
	};

	const actionButtons = (
		<Stack direction="row" spacing={1} alignItems="center">
			<AddContract />
			<FileButton
				variant="outlined"
				text="Nahrát dokument"
				size="small"
				onSelect={(a) => {
					if (a === "FileTooLarge") {
						toast.error("File too large");
					} else {
						onAddContractFromDocument("InvestmentContract", a.file, a.fileName);
					}
				}}
				sx={{
					alignSelf: { xs: "stretch", sm: "auto" },
				}}
				component={(fileInput) => {
					return (
						<ActiveUploadsBadge>
							<Button
								variant="text"
								color="primary"
								endIcon={<DocumentScanner />}
								component="label"
							>
								Nahrát dokument
								{fileInput}
							</Button>
						</ActiveUploadsBadge>
					);
				}}
			/>
		</Stack>
	);

	const filters = (
		<Stack direction="row" spacing={1} alignItems="center">
			<Stack direction="row" spacing={0.5}>
				{(
					[
						{ key: "all", label: "Všechno" },
						{ key: "pending", label: "Rozpracované" },
						{ key: "approved", label: "Schválené" },
						{ key: "rejected", label: "Zamítnuté" },
					] as const
				).map((filter) => (
					<Chip
						key={filter.key}
						label={filter.label}
						onClick={() => setActiveFilter(filter.key)}
						sx={{
							borderRadius: "16px",
							fontWeight: 500,
							backgroundColor:
								activeFilter === filter.key ? "primary.main" : "transparent",
							color: activeFilter === filter.key ? "#FFFFFF" : "text.primary",
							border:
								activeFilter === filter.key ? "none" : "1px solid #E9EAEB",
							"&:hover": {
								backgroundColor:
									activeFilter === filter.key ? "primary.dark" : "#F5F5F5",
							},
						}}
					/>
				))}
			</Stack>
			{/* <ToggleButton
				value="showIncomplete"
				selected={showIncomplete}
				onChange={() => setShowIncomplete(!showIncomplete)}
				size="small"
				sx={{
					border: "none",
					borderRadius: "16px",
					px: 2,
					py: 0.5,
					textTransform: "none",
					color: showIncomplete ? "error.main" : "text.secondary",
					"&.Mui-selected": {
						backgroundColor: "transparent",
						color: "error.main",
					},
					"&:hover": {
						backgroundColor: "transparent",
					},
				}}
			>
				Skrýt nevyplněné (2)
			</ToggleButton> */}
		</Stack>
	);

	return (
		<SectionCard
			title="Seznam rozpracovaných smluv"
			action={actionButtons}
			filters={filters}
			separateContent
		>
			<ContractsTable />
		</SectionCard>
	);
};
